/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { getProxyUrl } from '../../utils/image';
import { usePlayer } from '../../hooks/player';
import { getPlayerUrl } from '../../utils/routes';

function LeadersHero({ player }) {
  const { id, givenName, surName, logoImageUrl, imageHalf200 } = player;

  const [fullPlayer] = usePlayer(id);
  const playerImage = imageHalf200 ? getProxyUrl(imageHalf200, 165, 156) : '';
  const shirtNumber = _.get(fullPlayer, 'currentClub[0].shirtNumber', '#');

  const getPlayerName = () => {
    if (!fullPlayer?.displayName) {
      return { firstRow: givenName, secondRow: surName };
    }

    const displayName = fullPlayer?.displayName || '';
    const nameParts = displayName.split(' ');
    const firstRow = nameParts[0];
    const secondRow = nameParts.splice(1, nameParts.length).join(' ');

    return { firstRow, secondRow };
  };

  return (
    <div className="player-bust">
      <div className="player-bust__images">
        <img
          alt="player"
          className="player-bust__player-image"
          src={playerImage}
        />
        <img
          alt="team"
          className="player-bust__team-image"
          src={logoImageUrl}
        />
      </div>
      <a
        href={getPlayerUrl(fullPlayer?.teamAbbrv, fullPlayer?.displayName)}
        className="player-bust__info text-decoration-none"
      >
        <p className="player-bust__number m-0">{shirtNumber}</p>
        <p className="player-bust__name m-0">
          <p className="heading-h6 text-transform-none m-0">
            {getPlayerName()?.firstRow}
          </p>
          <o className="heading-h5 text-transform-none m-0">
            {getPlayerName()?.secondRow}
          </o>
        </p>
      </a>
    </div>
  );
}

LeadersHero.propTypes = {
  player: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    givenName: PropTypes.string.isRequired,
    surName: PropTypes.string.isRequired,
    logoImageUrl: PropTypes.string.isRequired,
    imageHalf200: PropTypes.string.isRequired,
  }).isRequired,
};

export default LeadersHero;
